import { NativePlatformAppLinksInterceptor } from "hub/src/context/AppLinksInterceptor/NativePlatformAppLinksInterceptor";
import { WebPlatformAppLinksInterceptor } from "hub/src/context/AppLinksInterceptor/WebPlatformAppLinksInterceptor";
import { getDeviceInfo } from "hub/src/utils/getDeviceInfo";

export const PlatformSpecificAppLinksInterceptor = getDeviceInfo().isNativeApp
  ? NativePlatformAppLinksInterceptor
  : WebPlatformAppLinksInterceptor;
